import React, { useState } from 'react';
import PropTypes from 'prop-types';

import IString from '../../common/components/i-string';
import WaitButton from '../../common/components/wait-button';

import { translate } from '../../common/i18n/localize';

function UpdateEmail(props) {
  const { email: originalEmail, onBackButtonClick, onSubmit, pending } = props;

  const [email, setEmail] = useState(originalEmail);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(email);
  };

  return (
    <>
      <h2 className='formTitle'>
        <IString stringKey='update.title' />
      </h2>
      <button className='backButton' aria-label={translate('general.back')} onClick={onBackButtonClick} />
      <form onSubmit={handleSubmit}>
        <p><IString stringKey='update.details' /></p>
        <fieldset className="chunk">
          <input type="email" placeholder={translate('update.email')} value={email || ''} required autoFocus onChange={e => setEmail(e.target.value)} />
        </fieldset>
        <fieldset className='actions noMarginAbove'>
          <WaitButton type='submit' wait={pending}>
            <IString stringKey='update.update' />
          </WaitButton>
        </fieldset>
      </form>
    </>
  );
}

UpdateEmail.propTypes = {
  email: PropTypes.string,
  onBackButtonClick: PropTypes.func,
  onSubmit: PropTypes.func,
  pending: PropTypes.bool
};

export default UpdateEmail;
